import {
  Cancel,
  CheckCircle,
  ForwardToInbox,
  WatchLater
} from '@mui/icons-material';
import IconButtonComponent from 'components/design-system/IconButton/IconButton';
import Text from 'components/design-system/Text/Text';
import { TooltipComponent } from 'components/design-system/Tooltip/Tooltip';
import { DICTONARY } from 'const/Dictonary';
import { useState } from 'react';
import gruposService from 'services/grupos';
import { AlertaExito } from 'utils/Alertas';

export const useEstadosSolicitarAdministracion = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [rowCount, setRowCount] = useState(1);
  const [pagination, setPagination] = useState(DICTONARY.PAGINACION.DEFAULT);
  const [globalFilter, setGlobalFilter] = useState('');
  const [columnFilters, setColumnFilters] = useState([]);
  const [dataTabla, setDataTabla] = useState([]);

  const solicitudCargarSolicitudes = async () => {
    setIsLoading(true);
    let query = {};
    if (pagination) {
      query.numPagina = pagination.pageIndex;
      query.totalPagina = pagination.pageSize;
    }
    try {
      const response = await gruposService.estadoSolicitudesAdministracion(
        query
      );
      if (response.status === 200) {
        const { content, totalElements, empty } = response.data;
        if (empty) {
          setDataTabla([]);
        } else if (Array.isArray(content)) {
          const formatedData = content.map(item => {
            let tipoSolcitidud =
              DICTONARY.SOLICITUD_ADMINISTRACION.TIPOS.EMPRESA;

            if (item.destinatarios.includes('Grupo')) {
              tipoSolcitidud = DICTONARY.SOLICITUD_ADMINISTRACION.TIPOS.GRUPO;
            }

            if (item.destinatarios.includes('Usuarios')) {
              tipoSolcitidud =
                DICTONARY.SOLICITUD_ADMINISTRACION.TIPOS.INVITACION;
            }

            if (item.destinatarios.includes('Sucursales')) {
              tipoSolcitidud =
                DICTONARY.SOLICITUD_ADMINISTRACION.TIPOS.SUCURSAL;
            }
            //FORMAT LA INFO PARA LA TABLA
            let totalInvitaciones = item.negocios.length;
            let totalAprobado = item.negocios.filter(
              item =>
                item.estado ===
                DICTONARY.SOLICITUD_ADMINISTRACION.ESTADOS.ACEPTADO
            ).length;
            let totalPendiente = item.negocios.filter(
              item =>
                item.estado ===
                DICTONARY.SOLICITUD_ADMINISTRACION.ESTADOS.PENDIENTE
            ).length;
            let totalRechazado = item.negocios.filter(
              item =>
                item.estado ===
                DICTONARY.SOLICITUD_ADMINISTRACION.ESTADOS.RECHAZADO
            ).length;

            let estado = {
              tipo: tipoSolcitidud,
              estado: item.estado,
              totalInvitaciones,
              totalAprobado,
              totalPendiente,
              totalRechazado,
              codigoSolicitud: item.codigoSolicitud
            };

            if (
              tipoSolcitidud ===
              DICTONARY.SOLICITUD_ADMINISTRACION.TIPOS.EMPRESA
            ) {
              estado.codigoDestinatario = item.negocios[0].codigoDestinatario;
            }

            if (
              tipoSolcitidud ===
              DICTONARY.SOLICITUD_ADMINISTRACION.TIPOS.SUCURSAL
            ) {
              estado.codigoDestinatario = item.negocios.map(
                negocio => negocio.codigoDestinatario
              );
            }

            return {
              codigoSolicitud: item.codigoSolicitud,
              destinatario: {
                tipo: tipoSolcitidud,
                titulo: item.destinatarios,
                detalle:
                  tipoSolcitidud ===
                    DICTONARY.SOLICITUD_ADMINISTRACION.TIPOS.EMPRESA ||
                  tipoSolcitidud ===
                    DICTONARY.SOLICITUD_ADMINISTRACION.TIPOS.SUCURSAL
                    ? null
                    : item.negocios
              },
              estado,
              fechaEnvio: item.fechaHoraSolicitud
            };
          });
          setDataTabla(formatedData);
          setRowCount(totalElements);
        }
      }
    } catch (error) {
      setDataTabla([]);
      return error;
    } finally {
      setIsLoading(false);
    }
  };

  const solicitarReenviarSolicitud = async params => {
    setIsLoading(true);
    try {
      const response = await gruposService.reenviarSolicitudesAdministracion(
        params
      );
      if (response.status === 200) {
        AlertaExito('La solicitud ha sido reenviada con éxito');
      }
      await solicitudCargarSolicitudes();
    } catch (error) {
      return error;
    } finally {
      setIsLoading(false);
    }
  };

  const getColumnaEstado = data => {
    if (
      data.tipo === DICTONARY.SOLICITUD_ADMINISTRACION.TIPOS.GRUPO ||
      data.tipo === DICTONARY.SOLICITUD_ADMINISTRACION.TIPOS.INVITACION
    ) {
      return (
        <div>
          <Text className="font-bold">
            {data.totalInvitaciones} invitaciones
          </Text>
          <div className="flex gap-4">
            <Text className="text-success-dark">
              <CheckCircle className="mr-1.5" /> {data.totalAprobado}
            </Text>
            <Text className="text-info-dark">
              <WatchLater className="mr-1.5" />
              {data.totalPendiente}
            </Text>
            <Text className="text-error-dark">
              <Cancel className="mr-1.5" />
              {data.totalRechazado}
            </Text>
          </div>
        </div>
      );
    }

    if (
      data.tipo === DICTONARY.SOLICITUD_ADMINISTRACION.TIPOS.EMPRESA ||
      data.tipo === DICTONARY.SOLICITUD_ADMINISTRACION.TIPOS.SUCURSAL
    ) {
      return getEtiquetaEstado(data.estado.toUpperCase());
    }

    return <></>;
  };

  const getEtiquetaEstado = estado => {
    if (
      estado ===
      DICTONARY.SOLICITUD_ADMINISTRACION.ESTADOS.PENDIENTE.toUpperCase()
    ) {
      return (
        <Text className="text-info-dark bg-info-light py-1 px-2 rounded-full inline-block">
          <WatchLater className="mr-1" />{' '}
          {DICTONARY.SOLICITUD_ADMINISTRACION.ESTADOS.PENDIENTE}
        </Text>
      );
    }

    if (
      estado ===
      DICTONARY.SOLICITUD_ADMINISTRACION.ESTADOS.ACEPTADO.toUpperCase()
    ) {
      return (
        <Text className="text-success-dark bg-success-light py-1 px-2 rounded-full inline-block">
          <CheckCircle className="mr-1" />{' '}
          {DICTONARY.SOLICITUD_ADMINISTRACION.ESTADOS.ACEPTADO}
        </Text>
      );
    }

    if (
      estado ===
      DICTONARY.SOLICITUD_ADMINISTRACION.ESTADOS.RECHAZADO.toUpperCase()
    ) {
      return (
        <Text className="text-error-dark bg-error-light py-1 px-2 rounded-full inline-block">
          <Cancel className="mr-1" />{' '}
          {DICTONARY.SOLICITUD_ADMINISTRACION.ESTADOS.RECHAZADO}
        </Text>
      );
    }
  };

  const getReenviarButton = (data, codigoSolicitud) => {
    if (data.estado !== DICTONARY.SOLICITUD_ADMINISTRACION.ESTADOS.PENDIENTE)
      return null;

    let params = {};
    if (codigoSolicitud) {
      params.codigoSolicitud = codigoSolicitud;
    }
    if (
      data.tipo === DICTONARY.SOLICITUD_ADMINISTRACION.TIPOS.GRUPO ||
      data.tipo === DICTONARY.SOLICITUD_ADMINISTRACION.TIPOS.EMPRESA
    ) {
      params.empresa = {
        codigoEmpresa: data.codigoDestinatario
      };
    }
    if (data.tipo === DICTONARY.SOLICITUD_ADMINISTRACION.TIPOS.INVITACION) {
      params.correosElectronicos = [data.destinatario];
    }
    if (data.tipo === DICTONARY.SOLICITUD_ADMINISTRACION.TIPOS.SUCURSAL) {
      params.sucursales = data.codigoDestinatario;
    }

    return (
      <TooltipComponent title="Reenviar solicitud">
        <IconButtonComponent
          type="secondary"
          className="ml-1.5"
          onClick={() => solicitarReenviarSolicitud(params)}
        >
          <ForwardToInbox />
        </IconButtonComponent>
      </TooltipComponent>
    );
  };

  return {
    getEtiquetaEstado,
    getReenviarButton,
    getColumnaEstado,
    solicitudCargarSolicitudes,

    pagination,
    isLoading,
    columnFilters,
    dataTabla,
    rowCount,
    setPagination,
    globalFilter,
    setColumnFilters,
    setGlobalFilter
  };
};
